<template>
  <v-container fluid>
    <v-layout align-start wrap justify-start>
      <v-flex xs4>
        <v-img
          :src="require('../assets/logo-soma-square.svg')"
          class="my-3"
          contain
          height="150"
        ></v-img>
      </v-flex>
      <v-flex xs12>
        <h2 class="display-2 font-weight-bold mb-3">
          Re:Login
        </h2>
        <v-flex xs4>
          <v-text-field
            label="Email"
            autofocus
            v-model="input.email"
            placeholder="Enter email to login"
          ></v-text-field>
        </v-flex>
        <br/>
        <v-flex xs4>
          <v-text-field
            label="Password"
            v-model="input.password"
            type="password"
            placeholder="Enter password to login"
          ></v-text-field>
        </v-flex>
        <br/>
        <v-btn type="button" v-on:click="doLogin()" round>Login</v-btn>
      </v-flex>
      <v-snackbar v-model="snackbar" :bottom="y === 'bottom'" :left="x === 'left'" :multi-line="mode === 'multi-line'"
        :right="x === 'right'" :timeout="timeout" :top="y === 'top'" :vertical="mode === 'vertical'" color='warning'>
          {{ text }}
        <v-btn color="black" flat @click="snackbar = false">Close</v-btn>
      </v-snackbar>
    </v-layout>
  </v-container>
</template>

<script>
  import axios from "axios";
  import { mapState, mapMutations } from 'vuex';

  export default {
      data() {
        return {
            input: {
                email: "",
                password: ""
            },
            snackbar: false,
            y: 'top',
            x: 'left',
            mode: '',
            timeout: 4000,
            test: '',
            authHeaderValue: ''
        }
    },
    methods: {
        ...mapMutations([
            'setAuthenticated',
            'setLoggedInUser',
            'setUserPassword',
            'setAuthToken'
        ]),
        doLogin() {
            this.setAuthenticated( false );
            this.setLoggedInUser( '' );
            this.makeAuthToken();
            var url = this.secureHost + "/thermocouple-services/tc/user/auth";
            if ( this.input.email != null ) {
                this.input.email = this.input.email.toLowerCase();
            }
            axios({ method: "POST", "url": url, "data": this.input, "headers": { "content-type": "application/json", "Accept": "application/json", "Authorization": this.authHeaderValue } }).then(result => {
                    this.setAuthenticated( true );
                    this.setLoggedInUser( result.data.users[0] );
                    this.setUserPassword( this.input.password );
                    this.$router.replace({name: "home"});
                }).catch(error => {
                    this.text = 'Authentication error, try again'
                    this.snackbar = true;
                })
        },
        makeAuthToken() {
            var encoded = btoa( this.serviceUser + ':' + this.servicePassword );
            this.authHeaderValue = 'Basic ' + encoded;
            this.setAuthToken( this.authHeaderValue );
        }
    },
    computed: {
        ...mapState([
            'secureHost',
            'serviceUser',
            'servicePassword'
        ])
    }
  }
</script>

<style>
</style>